export enum ReservationTerm {
  ONE_YEAR = 1,
  THREE_YEARS = 3,
}